export const LABEL_TEXT = {
	none: 'None',
	religion: 'Personal belief',
	politics: 'Political opinion',
	sexual: 'Sexual behavior',
	health: 'Health history',
	first_name: 'first name',
	last_name: 'last name',
	phone_num: 'phone number',
	birth_date: 'birthdate',
	email: 'E-mail',
	gender: 'Gender',
	education: 'Education',
	occupation: 'Occupation',
	license_num: 'License Number',
	account_num: 'Account Number',
	citizen_id: 'Citizen id',
	card_num: 'card number',
	address: 'address',
	password: 'password',
};